import React from 'react';
import { Link } from 'react-router-dom';
import { FaChartLine, FaCalendarAlt } from 'react-icons/fa';
import '../styles/AnnualReport.css';

const AnnualReport = () => {
  // Logo URL
  const logoUrl = "https://causeandimpact-assets.s3.us-east-1.amazonaws.com/causeandimpactlogowhite.png";

  return (
    // Ensure this class name matches the one used in your CSS
    <div className="annual-report-container">

      <h1>Annual Report</h1>

      <section className="coming-soon-section">

        {/* Logo moved here */}
        <div className="logo-container">
          <img src={logoUrl} alt="Cause and Impact Logo" className="logo" />
        </div>

        <h2>Transparency in Action</h2>

        <p>
          Our platform is built on the principle of transparency. As we launch and operate,
          we will share data-driven insights and updates about our impact. Stay tuned—our
          first annual report will be available after the close of our operating year.
        </p>

        <div className="cta-section">
          <p>
            Want to learn more about our mission while you wait?
          </p>
          <Link to="/our-story" className="cta-link">
            Explore Our Story
          </Link>
        </div>
      </section>
    </div>
  );
};

export default AnnualReport;